import React from 'react'
import Hero from './Hero/Hero'
import CardGroup from '../../common/CardGroup/CardGroup'
import ExternalLink from '../../common/ExternalLink/ExternalLink'
import Image from '../../common/Image/Image'
import { useNavigate } from 'react-router-dom'

import './Home.scss'

const Home = () => {
  const navigate = useNavigate()

  return (
    <div className='home'>
      <Hero />
      <CardGroup featured />
      <div className='about-brief'>
        <header>
          <h2 className='small-caps'>About</h2>
        </header>
        <div className='inner-container'>
          <Image
            className='windsor-image'
            path='me'
            fileName='windsor.jpg'
            caption='Here I am at Windsor Castle, in Windsor, UK.'
            alt='Jason at Windsor Castle, in Windsor, UK.'
          />
          <div className='text-container'>
            <p className='callout'>
              I distill complex problems into impactful design.
            </p>
            <p className='excerpt'>
              Currently, I work as a Supervisor, Sr. UX Designer for{' '}
              <ExternalLink url='https://www.icf.com' label='ICF' />, an agile
              leader in building digital health services and platforms.
            </p>
            <button className='btn primary' onClick={() => navigate('/about')}>
              More about me
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
